import React from 'react';
import { Card } from "react-bootstrap";
import face_viktoria_weigl_kovacs from "../../assets/img/face_viktoria_weigl_kovacs.png";
import face_bence_agg from "../../assets/img/face_bence_agg.png";
import ShowMoreText from "react-show-more-text";
import proj_network_viz from "../../assets/img/proj_network_viz.png";

const V_Weigl_Kovacs_and_B_Agg_network_viz = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_network_viz} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_viktoria_weigl_kovacs}
              alt="Acceleration of Entropy-Based Network Visualization"
            />{" "}
            <p className="text7">Viktória Weigl-Kovács</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_bence_agg}
              alt="Acceleration of Entropy-Based Network Visualization"
            />{" "}
            <p className="text7">Bence Károly Ágg</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Bioinformatics Laboratory, Department of Pharmacology and Pharmacotherapy, Semmelweis University</p>
            </div>
            <div>
            Network visualization is an effective tool for representing data of complex systems, this way
            facilitating hypothesis formulation and understanding such systems. The entropy-based network
            visualization provides a unified theory to reach a layout containing the most information, however
            the runtime of the currently available version is significantly slower than that of other widely used
            algorithms.
            <br />
            <br />
            The aim of this project:
            <ul>
                <li>
                  Implementing approximation and runtime-optimization methods for entropy-based network
                  visualization.
                </li>
                <li>
                  Comparison and evaluation of network visualization quality.
                </li>
            </ul>
            <br />
            <b>Requirements:</b> C++ programming skills
            <br />
            <br />

            Related literature:{" "}

            <ul>
                <li>
                <a href="https://www.nature.com/articles/srep13786">
                Kovács, I., Mizsei, R. & Csermely, P. (2015).A unified data representation theory for network visualization, 
                ordering and coarse-graining. Sci Rep 5, 13786</a>
                </li>
                <li>
                <a href="https://academic.oup.com/bioinformatics/article/35/21/4490/5475596">
                Ágg, B., Császár, A., Szalay-Bekő, M., Veres, D. V., Mizsei, R., Ferdinandy, P., … Kovács, I. A. (2019). 
                The EntOptLayout Cytoscape plug-in for the efficient visualization of major protein complexes in protein–protein 
                interaction and signalling networks. Bioinformatics, 35(21), 4490–4492. doi:10.1093/bioinformatics/btz257</a>
                </li>
            </ul>

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default V_Weigl_Kovacs_and_B_Agg_network_viz;